import { render, staticRenderFns } from "./caricomp.vue?vue&type=template&id=dbcf8e42&scoped=true&"
import script from "./caricomp.vue?vue&type=script&lang=js&"
export * from "./caricomp.vue?vue&type=script&lang=js&"
import style0 from "./caricomp.vue?vue&type=style&index=0&id=dbcf8e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcf8e42",
  null
  
)

export default component.exports